import { makeStyles } from '@material-ui/core/styles';

export const useFormHtmlTemplateStyles = makeStyles(theme => ({
  formHtmlTemplate: {
    flexGrow: 1
  },
  editor: {
    height: '720px',
    maxHeight: '720px',
    marginBottom: theme.spacing(2)
  }
}));
